import { PublishingState } from '@graphics/gfx-common/dist/types'
import { safeGet, publishingHostUrl } from './http'

const publishingLocationsUrl = `${publishingHostUrl}/publishing-locations`

export const getPublishingLocations = () => safeGet(`${publishingLocationsUrl}`)

export const getLocationStatus = (
  published: boolean,
  state: PublishingState,
  error: any
): 'failure' | 'published' | 'publishing' | '' =>
  (!!error && 'failure') ||
  (published && 'published') ||
  (['Pending', 'InProgress'].includes(state) && 'publishing') ||
  ''

export const isLocationPublic = (access?: string): boolean =>
  access === 'public'
export const isLocationMedia = (name: string): boolean =>
  name.startsWith('media')
